import { memo } from "react";
import Button from "@mui/material/Button";
import { useResourceContext } from "ui/widgets/Resource";

const CreateBankingSDKRecipient = () => {
    const { open, onOpen } = useResourceContext();

    const onClick = () => onOpen();

    return (
        <Button
            color='secondary'
            variant='contained'
            disabled={open}
            onClick={onClick}
        >
            Create Open Banking Recipient
        </Button>
    );
};

export default memo(CreateBankingSDKRecipient);
